import axios from '@/utils/axiosHelper';

// 解锁时间获取
export const onGetInitTimeAPI = (params) => {
    return axios({ url: '/snail/six/time', method: 'GET', params }, { interceptResultCode: false });
};


// 初始化
export const onGetInitDataAPI = (params) => {
    return axios({ url: '/snail/six/index', method: 'GET', params }, { interceptResultCode: false });
};

// 免密登录
// export const secretFreeLoginApi = (data) => {
//     return axios({ url: '/cherry/auth/login', method: 'POST', data }, { interceptResultCode: false });
// };


// 预约新服
export const bookAPI = (data) => {
    return axios({ url: '/snail/six/book', method: 'POST', data }, { interceptResultCode: false });
};

// 获取日记内容
export const getDiaryAPI = (params) => {
    return axios({ url: '/snail/six/diary', method: 'GET', params }, { interceptResultCode: false });
};

// 获取留言内容
export const getMessageAPI = (params) => {
    return axios({ url: '/snail/six/message/list', method: 'GET', params }, { interceptResultCode: false });
};

// 获取分享内容
export const getShareAPI = (params) => {
    return axios({ url: '/snail/six/share/info', method: 'GET', params }, { interceptResultCode: false });
};

// 上传测试报告
export const postQuestionAPI = (data) => {
    return axios({ url: '/snail/six/questionnaire', method: 'POST', data }, { interceptResultCode: false });
};

// 留言
export const postCommentAPI = (data) => {
    return axios({ url: '/snail/six/message', method: 'POST', data }, { interceptResultCode: false });
};

// 踩一下
export const pushStepAPI = (data) => {
    return axios({ url: '/snail/six/message/step', method: 'POST', data }, { interceptResultCode: false });
};


// 组队 加入队伍
export const teamJoinAPI = (data) => {
    return axios({ url: '/snail/six/team/entry', method: 'POST', data }, { interceptResultCode: false });
};

// 组队 离队（踢出队伍）
export const teamKickAPI = (data) => {
    return axios({ url: '/snail/six/team/exit', method: 'POST', data }, { interceptResultCode: false });
};

// 获取服务器时间
export const onGetTimeAPI = (params) => {
    return axios({ url: '/snail/six/time', method: 'GET', params }, { interceptResultCode: false });
};

export const downloadApps = (params) => {
    return axios({ url: "/jump/download/url", method: "POST", params }, { interceptResultCode: false });
};

// 获取服务器时间
export const onGetShowTimeAPI = (params) => {
    return axios({ url: '/snail/year/show', method: 'GET', params }, { interceptResultCode: false });
};

// // 获取服务器时间
// export const onGetTimeAPI = (params) => {
//   return axios({ url: '/snail/web-activity', method: 'GET', params }, { interceptResultCode: false });
// };


// WEBPACK FOOTER //
// ./src/pages/snail/yayaLand/api.js